import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { HANDLE_TOLERANCE, COLORS } from '../../constants';
export const Line = ({ definition: { width, strokeWidth, strokeColor = COLORS.DEFAULT_STROKE } }) => {
    const { PointerArea } = useContext(ComponentContext);
    const { SelectionMarker } = useContext(ComponentContext);
    return (React.createElement(React.Fragment, null,
        React.createElement("line", { "data-not-bounding": true, x1: "0", y1: "0", x2: width, y2: "0", stroke: strokeColor, strokeWidth: strokeWidth }),
        React.createElement(PointerArea, { width: width, height: HANDLE_TOLERANCE * 2, y: -HANDLE_TOLERANCE }),
        React.createElement(SelectionMarker, { y: -HANDLE_TOLERANCE, width: width, height: HANDLE_TOLERANCE * 2 })));
};
//# sourceMappingURL=line.js.map